import {
  INVOICE_BRAND_STORY,
  INVOICE_BRAND_STORY_HEADING,
  INVOICE_BRAND_TAGLINE,
} from '@fois-utsavvoice/shared';
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { STORE_LINKS } from '../brand.js';
import { Wordmark } from './Wordmark.js';

interface PageShellProps {
  children: ReactNode;
  footer?: ReactNode;
}

export function PageShell({ children, footer }: PageShellProps) {
  return (
    <div className="flex min-h-screen flex-col bg-cream">
      <header className="border-b border-linen bg-cream">
        <div className="mx-auto flex w-full max-w-6xl flex-col gap-3 px-5 py-5 sm:flex-row sm:items-center sm:justify-between sm:px-8">
          <Link to="/" aria-label="FESTIVALSOFINDIASTORE UtsavVoice home">
            <Wordmark compact />
          </Link>
          <nav
            aria-label="Store"
            className="flex flex-wrap items-center gap-x-6 gap-y-1 text-charcoal"
          >
            <a className="nav-link" href={STORE_LINKS.shopAll}>
              Shop All
            </a>
            <a className="nav-link" href={STORE_LINKS.givingBack}>
              Giving Back
            </a>
            <Link className="nav-link" to="/privacy">
              Privacy
            </Link>
          </nav>
        </div>
      </header>
      <main className="mx-auto flex w-full max-w-6xl flex-1 flex-col px-5 py-10 sm:px-8">
        {children}
      </main>
      <footer className="border-t border-linen bg-cream px-5 py-10 text-sm text-charcoal sm:px-8">
        <div className="mx-auto max-w-6xl space-y-6">
          {footer ?? (
            <>
              <p className="heading-lg text-crimson">{INVOICE_BRAND_STORY_HEADING}</p>
              <p className="max-w-3xl leading-relaxed">{INVOICE_BRAND_STORY}</p>
              <p className="font-bold uppercase tracking-brand text-kraft">{INVOICE_BRAND_TAGLINE}</p>
              <nav aria-label="Footer" className="flex flex-wrap gap-x-6 gap-y-2">
                <a className="nav-link" href={STORE_LINKS.about}>
                  About Us
                </a>
                <a className="nav-link" href={STORE_LINKS.shipping}>
                  Shipping Policy
                </a>
                <a className="nav-link" href={STORE_LINKS.returns}>
                  Returns &amp; Refunds
                </a>
                <a className="nav-link" href={STORE_LINKS.contact}>
                  Contact Us
                </a>
                <Link className="nav-link" to="/privacy">
                  Privacy notice
                </Link>
              </nav>
              <p className="text-charcoal/70">
                Questions about this feedback form? Email{' '}
                <a
                  className="font-bold text-crimson underline"
                  href="mailto:hello@festivalsofindiastore.com"
                >
                  hello@festivalsofindiastore.com
                </a>
                .
              </p>
            </>
          )}
        </div>
      </footer>
    </div>
  );
}
